module.exports = __webpack_public_path__ + "static/travelworld_footer-7acefc176cbab63539a8b76bce38c332.jpg";